module.exports = __webpack_public_path__ + "img/icon_card_play.ddaf08e7.png";